import React from 'react';
import { IconButton } from '@mui/material';
import { FiChevronDown, FiChevronUp, FiTrash2 } from 'react-icons/fi';
import { ProductBasket } from '../../../../../types/basket/ProductBasket';
import { DataTable } from '../../../../../shared/ui/dataTable';

type TableProductsProps = {
  products: ProductBasket[];
  disabled?: boolean;
  onChange: (products: ProductBasket[]) => void;
};

export const TableProducts: React.FC<TableProductsProps> = ({
  products,
  disabled = false,
  onChange,
}) => {
  function moveProductByOffset(productId: number, offset: number): void {
    const currentIndex = products.findIndex(
      (product) => product.id === productId
    );
    const targetIndex = currentIndex + offset;

    if (
      disabled ||
      currentIndex < 0 ||
      targetIndex < 0 ||
      targetIndex >= products.length
    ) {
      return;
    }

    const reorderedProducts = [...products];
    const [product] = reorderedProducts.splice(currentIndex, 1);
    reorderedProducts.splice(targetIndex, 0, product);
    onChange(reorderedProducts);
  }

  function removeProduct(productId: number): void {
    onChange(products.filter((product) => product.id !== productId));
  }

  return (
    <DataTable
      columns={[
        {
          id: 'position',
          header: 'Posição',
          cell: (_product, index) => index + 1,
        },
        {
          id: 'description',
          header: 'Produto',
          accessorKey: 'description',
        },
        {
          id: 'sap_code',
          header: 'Código SAP',
          accessorKey: 'sap_code',
        },
        {
          id: 'actions',
          header: 'Ações',
          cell: (product, index) => (
            <span style={{ whiteSpace: 'nowrap' }}>
              <IconButton
                size="small"
                aria-label={`Mover ${product.sap_code} para cima`}
                disabled={disabled || index === 0}
                onClick={() => moveProductByOffset(product.id, -1)}
              >
                <FiChevronUp />
              </IconButton>
              <IconButton
                size="small"
                aria-label={`Mover ${product.sap_code} para baixo`}
                disabled={disabled || index === products.length - 1}
                onClick={() => moveProductByOffset(product.id, 1)}
              >
                <FiChevronDown />
              </IconButton>
              <IconButton
                size="small"
                aria-label={`Remover ${product.sap_code}`}
                disabled={disabled}
                onClick={() => removeProduct(product.id)}
              >
                <FiTrash2 />
              </IconButton>
            </span>
          ),
        },
      ]}
      data={products}
      disabled={disabled}
      enableRowDragAndDrop
      getRowId={(product) => String(product.id)}
      onDataChange={onChange}
      emptyMessage="Nenhum produto adicionado."
    />
  );
};
